<template>
  <div class="sel-modal clearfix modal-container">
    <!-- <div class="sel-modal-header clearfix">
      <div class="search-box">
        <vxe-input v-model="logisticsNum" style="height: 34px !important;border: 1px solid #409eff;" type="search"
                   placeholder="搜索" @keyup.enter.native="search"
                   @search-click="search"></vxe-input>
      </div>
    </div>-->
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">物流信息</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box">
        <vxe-input
            v-model="logisticsNum"
            style="height: 34px !important;border: 1px solid #dcdee2;"
            type="search"
            placeholder="搜索"
            @keyup.enter.native="search"
            @search-click="search"
        ></vxe-input>
      </div>
    </div>
    <div>
      <vxe-table
          show-overflow
          highlight-hover-row
          stripe
          ref="xTable"
          class="table-style"
          height="400"
          align="center"
          border="none"
          :auto-resize="true"
          :loading="loading"
          :data="logisticsData"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column type="checkbox" width="40"></vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流编号" width="160">
          <template slot-scope="{ row }">
            <span
                @click="showLogisticsDetail(row.id)"
                style="color: #2D8CF0;cursor:pointer"
            >{{ row.logisticsNum }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsCode" title="物流单号" width="120"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货品名称" width="90"></vxe-table-column>
        <vxe-table-column field="goodsRule" title="规格" width="110"></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="60"></vxe-table-column>
        <vxe-table-column field="counts" title="装货数量" width="120"></vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="120"></vxe-table-column>
        <vxe-table-column field="deviate" title="盈亏数量" width="120"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="120"></vxe-table-column>
        <vxe-table-column field="voyage" title="航次号" width="90"></vxe-table-column>
        <vxe-table-column field="deliveryPlace" title="交货地点" width="100"></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
        <vxe-table-column field="endPlace" title="目的地" width="100"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运时间" width="140"></vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="140"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="detailVisible" title="查看物流详情" width="1300" height="600" resize remember>
      <view-detail-modal ref="modalDetail" :editVisible="false"></view-detail-modal>
    </vxe-modal>
    <div class="modal-footer">
      <Button @click="cancel">取 消</Button>
      <Button status="primary" @click="commit" style="margin-left: 10px">确 认</Button>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import ViewDetailModal from "@/views/logistics/DetailModal";
  import moment from "moment";

  export default {
    name: "Logistics",
    components: {ViewDetailModal},
    props: {
      orderTypeTwo: {
        type: [String, Number],
        default: null,
      },
      orderNum: {
        type: [String, Number],
        default: null,
      },
    },
    data() {
      return {
        selectTab: "tab1",
        detailVisible: false,
        logisticsNum: null,
        logisticsData: [],
        ordersBuyerNum: null,
        ordersSellerNum: null,
        ordersSellerLv2Num: null,
        loading: false,
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        trackFlag: false,
        url: "",
        isCar: true,
        records: [],
      };
    },
    created() {
      console.log(this.orderNum);
    },

    methods: {
      async selectAllEvent({checked, records}) {
        if (checked) {
          let res = await $api.logistics.request("queryLogisticsList", {
            page: 1,
            rows: 10000,
            logisticsNum: this.logisticsNum,
            ordersBuyerNum: this.ordersBuyerNum,
            ordersSellerLv2Num: this.ordersSellerLv2Num,
            ordersSellerNum: this.ordersSellerNum,
            orderBy: 2,
          });
          if (res.status === 1) {
            this.records = res.data.rows;
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            });
          }
        } else {
          this.records = [];
        }
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      init() {
        this.logisticsNum = null;
        this.page = {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        };
        this.queryLogisticsList();
      },
      async queryLogisticsList() {
        this.loading = true;
        this.ordersBuyerNum = null;
        this.ordersSellerNum = null;
        this.ordersSellerLv2Num = null;
        if (this.orderTypeTwo === 1) {
          this.ordersBuyerNum = this.orderNum;
        } else if (this.orderTypeTwo === 2) {
          this.ordersSellerNum = this.orderNum;
        } else if (this.orderTypeTwo === 3) {
          this.ordersSellerLv2Num = this.orderNum;
        }
        let res = await $api.logistics.request("queryLogisticsList", {
          page: this.page.currentPage,
          rows: this.page.pageSize,
          logisticsNum: this.logisticsNum,
          ordersBuyerNum: this.ordersBuyerNum,
          ordersSellerLv2Num: this.ordersSellerLv2Num,
          ordersSellerNum: this.ordersSellerNum,
          orderBy: 2,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          let logisticsData = res.data.rows;
          logisticsData.map((i) => {
            i.beginTime = this.$utils.toDateString(i.beginTime, "yyyy-MM-dd");
            i.endTime = this.$utils.toDateString(i.endTime, "yyyy-MM-dd");
            i.createTime = this.$utils.toDateString(i.createTime, "yyyy-MM-dd");
          });
          this.logisticsData = logisticsData;
          this.logisticsData.map((i) => {
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xTable.setCheckboxRow(i, true);
              }
            });
          });
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      showLogisticsDetail(id) {
        if (!this.isHavePermission('logistics:queryLogisticsDetail')){
          this.$Message["info"]({
            background: true,
            content: "对不起，您没有该权限！"
          });
          return ;
        }
        this.detailVisible = true;
        this.$refs.modalDetail.queryLogisticsDetail(id);
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.queryLogisticsList();
      },
      clickEvent3(id) {
        this.$refs[id].togglePanel();
      },
      search() {
        this.page.currentPage = 1;
        this.page.pageSize = 10;
        this.queryLogisticsList();
      },
      commit() {
        this.$emit("choose", this.records);
        this.close();
      },
      cancel() {
        this.$emit("close");
      },
      close() {
        this.logisticsData = [];
        this.records = [];
        this.$refs.xTable.clearCurrentRow();
      },
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }
</style>